var _style, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMission(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1A8F3F;}\n\t.st1{fill:#2B4250;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard 28") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.5,81.2v22.4l-41.9,41.9c-2.5,2.4-2.5,6.4-0.1,8.8c2.4,2.5,6.4,2.5,8.8,0.1c0,0,0.1-0.1,0.1-0.1l41.9-41.9 h22.4c1.7,0,3.2-0.7,4.4-1.8l37.5-37.5c2.4-2.4,2.4-6.4,0-8.8c-1.2-1.2-2.8-1.8-4.4-1.8h-18.8V43.8c0-3.5-2.8-6.2-6.3-6.2 c-1.7,0-3.2,0.7-4.4,1.8l-37.5,37.5C188.2,78,187.5,79.6,187.5,81.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.3,91.2l-18.7,18.7c22.2,50.6-0.9,109.7-51.5,131.8s-109.7-0.9-131.8-51.5s0.9-109.7,51.5-131.8 c25.6-11.2,54.7-11.2,80.3,0l18.7-18.7C147.8,7.2,72.1,30.3,39.6,91.2s-9.4,136.7,51.5,169.2s136.7,9.4,169.2-51.5 C279.9,172.1,279.9,128,260.3,91.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M175,81.2c0-4.9,1.9-9.7,5.4-13.2c-45.4-17-96,6.1-113,51.5s6.1,96,51.5,113s96-6.1,113-51.5 c7.4-19.8,7.4-41.6,0-61.5c-3.5,3.5-8.2,5.5-13.2,5.4h-11.5c13.9,31.7-0.5,68.7-32.2,82.6c-31.7,13.9-68.7-0.5-82.6-32.2 s0.5-68.7,32.2-82.6c16-7,34.3-7,50.3,0V81.2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M169.5,104c-25.4-10.8-54.8,1.1-65.5,26.5s1.1,54.8,26.5,65.5c25.4,10.8,54.8-1.1,65.5-26.5 c5.3-12.5,5.3-26.5,0-39l-32.8,32.8c-7.3,7.3-19.2,7.4-26.5,0.1c-7.3-7.3-7.4-19.2-0.1-26.5c0,0,0.1-0.1,0.1-0.1L169.5,104z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMission);
export default __webpack_public_path__ + "static/media/mission.b83ee17115611024cd844f5f532c8c1e.svg";
export { ForwardRef as ReactComponent };